export default {
    // PREVIEW functionality
    EDITOR: 'Editor',
    PREVIEW: 'Preview',
    PLAYER: 'Player',
    VIDEO_EDITOR: 'VideoEditor',
    AUDIO_EDITOR: 'AudioEditor',
    DOWNLOAD: 'download',
    PRINT: 'print',
    PRINT_EDITOR: 'printEditor',
    AUDIO_TOOL: 'audioTool',
    AUDIO_TOOL_PLAYER: 'audioToolPlayer',
    EXPORT_PLAYER: 'exportPlayer',
    EXPORT_AUDIO_PLAYER: 'exportAudioPlayer',

    // CONTEXT MENU functionality
    OBJECT_CONTEXT_ADVANCED: 'Object_context_advanced',
    OBJECT_CONTEXT_STYLING: 'Object_context_styling',
    OBJECT_TEXT_STYLING: 'Object_text_styling',
    TEXT_EDITOR: 'Text_editor',
    MIND_MAP_MENU: 'Mind_map_menu',
    OBJECT_CONTEXT_MOODS: 'Object_context_moods',
    ANIMATION_CONTEXT: 'Animation_context',
    SIZE_AND_POSITION_CONTEXT: 'Size_and_position_context',
    SLIDE_CONTEXT_ADVANCED: 'Slide_context_advanced',
    SLIDE_CONTEXT_STYLING: 'Slide_context_styling',
    SLIDE_CONTEXT_MOODS: 'Slide_context_moods',
    SLIDE_VISIBILITY: 'Slide_visibility',
    SAVE_CONTEXT: 'Save_context',
    SEARCH_CONTEXT: 'Search_context',
    CONTEXT_NONE: 'Context_none',
    ZOOM_SLIDE_CONTEXT: 'Zoom_slide_context',
    LINE_CONTEXT: 'line_context',
    FREEHAND_CONTEXT: 'freehand_context',

    // Left menu
    TEXT: 'Text',
    RICH_TEXT: 'RichText',
    FREEHAND: 'Freehand',
    SHAPES: 'Shapes',
    EFFECTS: 'Effects',
    FRAMES: 'Frames',
    MEDIA: 'Media',

    FILL_STYLE: 'fill',
    LINE_STYLE: 'line',

    IMAGES: 'images',
    SOUNDS: 'sounds',
    VIDEOS: 'videos'
};



/** WEBPACK FOOTER **
 ** ./src/constants/ModeConstants.js
 **/